module.exports = __webpack_public_path__ + "static/media/fuel-system-cleaning.34316315.svg";